module.exports = __webpack_public_path__ + "td.svg?d39cd5f948f8c8de3a6486c944e4d908";